/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RouteConnectionIssueEnum =
  (typeof RouteConnectionIssueEnum)[keyof typeof RouteConnectionIssueEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RouteConnectionIssueEnum = {
  NoTransitFound: 0,
  WaitTooLong: 1,
  TransitTooLong: 2,
  ArrivesTooLate: 3,
  BudgetExhausted: 4,
  LookupFailed: 5,
  DepartsDayBefore: 6,
} as const;
